var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[(!_vm.isLenovoWeb)?_c('div',{staticClass:"footer-info"},[_c('img',{attrs:{"src":"/Account/images/signin/tips.png"}}),_c('span',[_vm._v("请使用Chrome 80+，Firefox 110+，360 14+，Edge 80+，QQ 11+，搜狗 11+，Safari 16+浏览器")]),_c('span',{staticClass:"down-brower",on:{"click":_vm.onDownBrower}},[_vm._v("下载Chrome浏览器")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }